import {
  ContentIslands,
  ContentSheet,
  ContentTransparency,
  FontDefault,
  FontMono,
  FontSerif,
  PresetBlue,
  PresetBlueprint,
  PresetDark,
  PresetSandstone,
  PresetSlateGreen,
  PresetWhite,
} from '@lib/icons/publish'
import {
  PublishContent,
  PublishFonts,
  PublishPresets,
} from '@storeOld/reducers/publish'

export const getIcon = (
  value: PublishPresets | PublishFonts | PublishContent
) => {
  switch (value) {
    case PublishPresets.DEFAULT: {
      return <PresetWhite />
    }
    case PublishPresets.BLUEPRINT: {
      return <PresetBlueprint />
    }
    case PublishPresets.SANDSTONE: {
      return <PresetSandstone />
    }
    case PublishPresets.BLUE: {
      return <PresetBlue />
    }
    case PublishPresets.SLATE_GREEN: {
      return <PresetSlateGreen />
    }
    case PublishPresets.DARK: {
      return <PresetDark />
    }
    case PublishFonts.DEFAULT: {
      return <FontDefault />
    }
    case PublishFonts.SERIF: {
      return <FontSerif />
    }
    case PublishFonts.MONO: {
      return <FontMono />
    }
    case PublishContent.SHEET: {
      return <ContentSheet />
    }
    case PublishContent.TRANSPARENT: {
      return <ContentTransparency />
    }
    case PublishContent.ISLANDS: {
      return <ContentIslands />
    }
    default: {
      return null
    }
  }
}
